module.exports = __webpack_public_path__ + "img/bad-connection.13535e1d.svg";